import * as React from 'react'

import { TFOrderPromoCodes } from '~graphql/generated/clientGraphql'
import { FORM_HORIZONTAL_SPACE, FORM_INPUT_RADIUS } from '~shared/segments/Form'
import { ButtonIcon } from '~ui/components/buttons/ButtonIcon/ButtonIcon'
import { Card } from '~ui/components/content/Card/Card'
import { IconDeleteFill } from '~ui/components/icons/specific/IconDelete'
import { GridRow } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TPromoCode = TFOrderPromoCodes['promoCodes'][number]

type TProps = NoChildren & {
  isDisabled: boolean
  promoCode: TPromoCode
  onRemove: (codeId: ID) => void
}

/**
 * Renders a single promo code that is currently applied to the form order
 * and a button to remove that code from the order.
 */
export const AppliedPromoCode: React.FC<TProps> = ({ promoCode, onRemove, isDisabled }) => {
  return (
    <GridRow gap={FORM_HORIZONTAL_SPACE} gridTemplateColumns={`1fr auto`}>
      <Card
        shadow={`none`}
        display={`grid`}
        alignItems={`center`}
        padding={{ vertical: `extraSmall`, horizontal: `medium` }}
      >
        <Text fontStyle={`boldSemi`} fontSize={`s14`}>
          {promoCode.code}
        </Text>
      </Card>
      <ButtonIcon
        bgColor={`error`}
        iconSize={`1.2rem`}
        icon={IconDeleteFill}
        radius={FORM_INPUT_RADIUS}
        onClick={() => onRemove(promoCode.id)}
        state={isDisabled ? `disabled` : `enabled`}
        padding={{ vertical: `extraSmall`, horizontal: `smallMedium` }}
      />
    </GridRow>
  )
}
